export default __webpack_public_path__ + "static/media/Rerebrace of the Death Master.bc16d6c1.jpg";